<div class="e-card">
  <div class="e-card-content min-height">
    <form id="exportJobForm" [formGroup]="exportJobForm" class="form-horizontal" autocomplete="off">

      <div class="form-row row">
        <div class="col-12 col-lg-6">
          <div class="form-group row">
            <label class="col-5 control-label required">
              {{'i18n.domain.export-jobs.fields.type' | translate}}
            </label>
            <div class="col-7">
              <ejs-dropdownlist [dataSource]="jobTypes"
                                [fields]="enumDropdownSettings"
                                id="type"
                                formControlName="type">
                <ng-template #itemTemplate let-data>
                  {{data.text | translate}}
                </ng-template>
                <ng-template #valueTemplate let-data>
                  <div class="centered">
                    <span>{{data.text | translate}}</span>
                  </div>
                </ng-template>
              </ejs-dropdownlist>
              <app-error-messages [control]="exportJobForm.controls.type"></app-error-messages>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group row">
            <label class="col-5 control-label">{{'i18n.domain.export-jobs.fields.fileType' | translate}}</label>
            <div class="col-7">
              <ejs-dropdownlist [dataSource]="fileTypes"
                                [fields]="enumDropdownSettings"
                                id="fileType"
                                formControlName="fileType">
                <ng-template #itemTemplate let-data>
                  {{data.text | translate}}
                </ng-template>
                <ng-template #valueTemplate let-data>
                  <div class="centered">
                    <span>{{data.text | translate}}</span>
                  </div>
                </ng-template>
              </ejs-dropdownlist>
              <app-error-messages [control]="exportJobForm.controls.fileType"></app-error-messages>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group row">
            <label
              class="col-5 control-label">{{'i18n.domain.export-jobs.fields.month' | translate}}:</label>
            <div class="col-7">
              <ejs-datepicker #monthPicker
                              formControlName="fromDate"
                              format="MMM yyyy"
                              class="me-2"
                              id="fromDate"
                              [start]="calendarStart"
                              [depth]="calendarDepth">
              </ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="form-group row">
            <label class="col-5 control-label">{{'i18n.shared.fields.company' | translate}}:</label>
            <div class="col-7">
              <ejs-dropdownlist #companyId
                                [dataSource]="companiesData"
                                [fields]="companyDropdownSettings"
                                [showClearButton]="true"
                                id="companyId"
                                formControlName="companyId">
              </ejs-dropdownlist>
            </div>
          </div>
        </div>
      </div>
      @if (exportJobForm.controls.id.value == null) {
      <div class="form-row row mt-5">
        <div class="col-12 d-flex justify-content-center">
          <div class="col-12 col-md-6 mx-auto">
            <div class="d-flex align-items-center mb-2">
              <label class="control-label mb-0 me-2">
                {{'i18n.domain.export-jobs.fields.template' | translate}}
              </label>
              <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.export-jobs.messages.tooltip' | translate }}">
                <span class="icon-information"></span>
              </ejs-tooltip>
            </div>
            <div #dropArea class="uploader mb-2">
              <ejs-uploader #defaultupload
                            [allowedExtensions]="allowedExtensions"
                            multiple="false"
                            [autoUpload]="false"
                            (removing)="onFileRemove()"
                            (selected)="handleFileInput($event)"
                            [dropArea]='dropArea'>
              </ejs-uploader>
            </div>
            <div class="d-flex justify-content-end">
              <button type="button" (click)="downloadTemplate()" class="btn btn-outline-secondary btn-fixedw rounded">
                {{ 'i18n.domain.export-jobs.edit.base-template' | translate }}
                <span class="e-btn-icon icon-download e-icons"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
      }
      @if (exportJobForm.controls.id.value !== null &&
      exportJobForm.controls.id.value !== undefined) {
      <ng-container>
        <hr>
        <div class="form-group row">
          <div class="col-6">
            <label class="col-5 control-label">{{'i18n.domain.export-jobs.edit.created-on' | translate}}</label>
            <label class="col-7 align-items-center">{{getDisplayDateTime(exportJobForm.controls.createdOn.value)}}</label>
          </div>
          <div class="col-6">
            <label class="col-5 control-label">{{'i18n.domain.export-jobs.edit.created-by' | translate}}</label>
            <label class="col-7 align-items-center">
              {{exportJobForm.controls.initiatedByUser?.value ? exportJobForm.controls.initiatedByUser?.value?.firstname + ' ' + exportJobForm.controls.initiatedByUser?.value?.lastname : "-"}}</label>
          </div>
        </div>

        @if (exportJobForm.controls.status.value == ExportJobStatus.Completed) {
        <div class="form-group row">
          <div class="col-6">
            <label class="col-5 control-label">{{'i18n.domain.export-jobs.edit.last-execution' | translate}}</label>
            <label class="col-7 align-items-center">{{getDisplayDateTime(exportJobForm.controls.executedOn.value) ?? "-"}}</label>
          </div>
          <div class="col-6">
            <label class="col-5 control-label">{{'i18n.domain.export-jobs.edit.purge-on' | translate}}</label>
            <label class="col-7 align-items-center">{{getDisplayDateTime(exportJobForm.controls.purgeDataOn.value) ?? "-"}}</label>
          </div>
        </div>
        }

        <div class="form-row row mt-5">
          <div class="col-12">
            <div class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2">
              <span class="control-label me-2">{{'i18n.domain.export-jobs.fields.status' | translate}}:</span>
              <span class="control-label">{{getStatusDisplayName(exportJobForm?.controls?.status?.value) | translate}}</span>
              <span class="status-bubble {{statusClassName}}"></span>
              @if(exportJobForm.controls.status.value == ExportJobStatus.Completed){
              <span class="control-label ms-4">{{'i18n.domain.export-jobs.edit.download' | translate}}</span>
              <button type="button" class="btn btn-primary btn-floating me-md-3" data-mdb-ripple-init (click)="downloadFile()">
                <span class="e-btn-icon icon-download e-icons"></span>
              </button>
              <span class="control-label ms-4">{{'i18n.domain.export-jobs.edit.download-log' | translate}}</span>
              <button type="button" class="e-lib e-btn e-control icon-btn e-icon-btn log-btn" data-mdb-ripple-init (click)="downloadExecutionLog()">
                <span class="e-btn-icon icon-document e-icons"></span>
              </button>
              }
            </div>
          </div>
        </div>
      </ng-container>
      }
    </form>
  </div>
  <div class="e-card-actions">
    <div class="right">
      <button type="reset" (click)="closeForm()" class="btn btn-outline-secondary btn-fixedw rounded">
        {{ 'i18n.domain.export-jobs.edit.cancel' | translate }}
      </button>
      @if (exportJobForm.controls.id.value == null) {
      <button type="submit" (click)="onCreate()" class="btn btn-primary btn-fixedw rounded ms-2">
        {{ 'i18n.domain.export-jobs.edit.create' | translate }}
      </button>
      }
      @if (exportJobForm.controls.id.value != null && exportJobForm.controls.status.value != ExportJobStatus.InProgress) {
      <button type="button" (click)="deleteJob()" [disabled]="disabledDelete" class="btn btn-outline-danger ms-2 ">
        {{ 'i18n.domain.export-jobs.edit.delete' | translate }}
        <span class="e-icons icon-trash-can danger ms-2"></span>
      </button>
      }
    </div>
  </div>
</div>
